<template>
  <div class="generator-cont">
     <router-link class="btn btn-transparent_blue"
                  to="/users"
                  @click.native="closeEdit"
                  v-if="type == 'userControl'">
       {{$t('btns.users.controlUsers')}}
     </router-link>

    <router-link class="btn btn-transparent_blue"
                 to="/things"
                 @click.native="closeEdit"
                 v-if="type == 'thingsControl'">
      {{$t('btns.users.controlThings')}}
    </router-link>

    <router-link class="btn btn-transparent_blue"
                 to="/dashboards"
                 @click.native="closeEdit"
                 v-if="type == 'dashboardsControl'">
      {{$t('btns.users.controlDashboards')}}
    </router-link>

    <button type="button"
            @click="delUser"
            v-if="type == 'delete'"
            class="btn btn-transparent_red">
      {{$t('btns.users.delUser')}}
    </button>

    <copy-btn :text="$t('btns.users.copyBtn')"
              v-if="type == 'copyId'"
              :value="copyId"></copy-btn>

    <div class="button-wrap">
      <button type="button"
              @click="showActivationLink"
              class="btn btn-transparent_blue"
              v-if="type == 'showActiveLink' && activationLinkShow">
        {{$t('btns.users.showActivatonLink')}}
      </button>
      <a v-else-if="type == 'showActiveLink' && !activationLinkShow"
         :href="activationLink"
         target="_blank"
         class="btn btn-transparent_blue">{{activationLink}}</a>
    </div>

    <button type="button"
            class="btn btn-transparent_blue"
            @click="repeatActivation"
            v-if="type == 'repeatActivation'">
      {{$t('btns.users.repeatActivation')}}
    </button>

    <button type="button"
            class="btn btn-transparent_blue"
            @click="enterAsUser"
            v-if="type == 'enterAsUser'">
      {{$t('btns.users.enterAsUser')}}
    </button>

  </div>
</template>


<script>
  import copyBtn from '../../../copyBtn'
  import {showOverlay} from "../../../../mixins/utils/showOverlay";

  export default {
    name: 'usersBtnsGenerator',
    props: {
      type: {
        type: String
      },
      copyId: {
        type: Number || String,
        required: false
      },
      activationLink: {
        type: String,
        required: false
      }
    },
    mixins: [showOverlay],
    components: {
      copyBtn
    },
    data() {
      return {
        activationLinkShow: true
      }
    },
    methods: {
      closeEdit() {
        this.showOverlay(false);
        this.editUserToggle(false);
      },
      delUser() {
        this.$emit('delUser')
      },
      showActivationLink() {
        this.activationLinkShow = false;
        setTimeout(() => this.activationLinkShow = true, 2500)
      },
      repeatActivation() {
        this.$emit('repeatActivation')
      },
      enterAsUser() {
        this.$emit('enterAsUser')
      }
    }
  }
</script>
